import type { UserNoteTypeII } from '../../../types/types';

/**
 * Note ids eligible for bulk selection. Selection only exists to feed bulk
 * delete, and signed notes can't be deleted (GDN-2354), so they are excluded.
 * Both select-all and the "all selected" derivation must use this same set —
 * comparing against the full page length would leave the Select All toggle
 * permanently out of sync on pages containing signed notes.
 */
export const getDeletableNoteIds = (notes: UserNoteTypeII[]): string[] =>
  notes.filter(note => !note.is_signed).map(note => note.note_id);
